module.exports = __webpack_public_path__ + "assets/78b008dd8cd9f0f4e5dee30c1fd04c25.jpg";